import React from 'react';

const SM = ({ className }: { className?: string }) => (
  <svg
    className={className}
    width="21"
    height="15"
    viewBox="0 0 21 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <mask
      id="mask0_3_42"
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="21"
      height="15"
    >
      <path
        d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask0_3_42)">
      <path
        d="M19 0H2C0.89543 0 0 0.89543 0 2V13C0 14.1046 0.89543 15 2 15H19C20.1046 15 21 14.1046 21 13V2C21 0.89543 20.1046 0 19 0Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 7H21V15H0V7Z"
        fill="#69BEE7"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8 4H13V5L10.5 6L8 5V4Z"
        fill="#E6BD34"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13 8.5C13 7.12 11.88 6 10.5 6C9.12 6 8 7.12 8 8.5C8 9.88 9.12 11 10.5 11C11.88 11 13 9.88 13 8.5ZM10.5 10C11.328 10 12 9.105 12 8C12 6.895 11.328 6 10.5 6C9.672 6 9 6.895 9 8C9 9.105 9.672 10 10.5 10Z"
        fill="#406421"
      />
      <path
        d="M10.5 9C10.7761 9 11 8.55228 11 8C11 7.44772 10.7761 7 10.5 7C10.2239 7 10 7.44772 10 8C10 8.55228 10.2239 9 10.5 9Z"
        fill="#D5B852"
      />
      <path
        d="M19 0.5H2C1.17157 0.5 0.5 1.17157 0.5 2V13C0.5 13.8284 1.17157 14.5 2 14.5H19C19.8284 14.5 20.5 13.8284 20.5 13V2C20.5 1.17157 19.8284 0.5 19 0.5Z"
        stroke="black"
        strokeOpacity="0.1"
      />
    </g>
  </svg>
);

export default SM;
